import React, { useEffect, useState } from 'react'
import * as web3Service from '../../../blockchain/web3.service'
import { DateTime } from 'luxon'
import { Spin, Button } from 'antd'
import { DashboardOutlined } from '@ant-design/icons'
import { useWeb3React } from '@web3-react/core'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventEmitter from '../../../Utils/EventEmitter'

export default function BreedMoreButton(props) {

  const { accountAddress } = props

  const [cumulativeCompoundPercentage, setCumulativeCompoundPercentage] = useState(0.00)
  const [isBreedingOnHold, setIsBreedingOnHold] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [isBreadMoreDragonsLoading, setIsBreadMoreDragonsLoading] = useState(false)
  const [logs, setLogs] = useState(null)

  useEffect(() => {
    const onNewLogs = (eventData) => {
      setLogs(eventData)
    }
    const listener = EventEmitter.addListener('HireDragonEvent', onNewLogs)
    return () => {
      listener.remove()
    }
  }, [])


  const { account, library } = useWeb3React()

  useEffect(() => {
    if (accountAddress) {
      fetchAllTheDataForCalculation(accountAddress)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountAddress, logs])


  const fetchAllTheDataForCalculation = async (accountAddress) => {
    setIsLoading(true)
    await calculateBreedMoreCompoundBonus(accountAddress)
    await calculateNextBonusRound()
    setIsLoading(false)
  }

  const calculateNextBonusRound = async () => {

    const userDetailsResponse = await web3Service.getDragonDetailsByUserAddress(accountAddress)
    let lastHatchTimestamp = null
    if (userDetailsResponse && userDetailsResponse.lastHatchTimestamp) {
      lastHatchTimestamp = parseInt(userDetailsResponse.lastHatchTimestamp)
    }
    try {
      if (lastHatchTimestamp) {
        const compoundSteps = await web3Service.getCompoundSteps()
        const compoundCumulative = lastHatchTimestamp + parseInt(compoundSteps)
        const timestampMills = DateTime.fromSeconds(compoundCumulative).toMillis()
        const diff = timestampMills - DateTime.now().toMillis()
        if (diff > 0) {
          setIsBreedingOnHold(true)
        } else {
          setIsBreedingOnHold(false)
        }
      } else {
        setIsBreedingOnHold(false)
      }
    } catch (error) {
      setIsBreedingOnHold(false)
      console.error("ERROR breed more button component next bonus round ", error)
    }
  }


  const calculateBreedMoreCompoundBonus = async (accountAddress) => {
    try {

      const userDetailsResponse = await web3Service.getDragonDetailsByUserAddress(accountAddress)

      if (userDetailsResponse && userDetailsResponse.dailyCompoundBonus) {
        const dailyCompoundBonusInt = parseInt(userDetailsResponse.dailyCompoundBonus)
        const compoundBonusResponse = await web3Service.getCompoundBonus()
        const extraBonus = parseFloat(compoundBonusResponse) * parseFloat(dailyCompoundBonusInt)
        if (extraBonus) {
          setCumulativeCompoundPercentage(extraBonus)
        } else {
          setCumulativeCompoundPercentage(0.00)
        }
      } else {
        setCumulativeCompoundPercentage(0.00)
      }

    } catch (error) {
      console.error("ERROR breed more button component calculate compound bonus ", error)
      setCumulativeCompoundPercentage(0.00)
    }
  }


  const handleBreadMoreDragons = async () => {
    try {
      setIsBreadMoreDragonsLoading(true)
      //check if user logged into the system
      if (!account) {
        toast.error("Please connect your wallet to continue")
        setIsBreadMoreDragonsLoading(false)
        return
      }

      const response = await web3Service.hireMoreDragons(library.getSigner())
      toast.success("Congratulation you have hire more dragons!")
      console.log(response)
      setIsBreadMoreDragonsLoading(false)
      EventEmitter.emit('HireDragonEvent', { isSuccess: true })
    } catch (error) {
      let errorMessage = "Something went wrong"
      if (error && error.message) {
        errorMessage = error.message
      }

      if (error && error.data) {
        errorMessage = error.data.message
      }
      toast.error(errorMessage)
      setIsBreadMoreDragonsLoading(false)
    }
  }


  return (
    <div>
      {
        isLoading ? (
          <div className='d-flex justify-content-center loading-container'>
            <Spin style={{ color: 'red' }} size="small" />
          </div>
        ) : (
          <Button
            block
            onClick={handleBreadMoreDragons}
            loading={isBreadMoreDragonsLoading}
            className='hiring-dragons-btn'
            type="primary"
            disabled={isBreedingOnHold}
            shape="round"
            icon={<DashboardOutlined />}
            size="large"
          >
            Bread More Dragons (+{cumulativeCompoundPercentage}%)
          </Button>
        )
      }

    </div>
  )
}
